import { Locale } from '@ps-smart-cp/ppfw-client';

const depreciationStatusClassNameConfig = {
  depreciating: new Map([
    [Locale.ja, '償却中'],
    [Locale.en, 'Depreciating'],
  ]),
  residualAchievement: new Map([
    [Locale.ja, '残存到達'],
    [Locale.en, 'Residual Achievement'],
  ]),
  residualDepreciation: new Map([
    [Locale.ja, '残存償却'],
    [Locale.en, 'Residual Depreciation'],
  ]),
  depreciationComplete: new Map([
    [Locale.ja, '償却完了'],
    [Locale.en, 'Depreciation Complete'],
  ]),
} satisfies Record<string, Map<Locale, string>>;

export { depreciationStatusClassNameConfig };
